'use client';
import classNames from 'classnames';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import gtm from 'eco-design-reliance/gtm';
import React, { useEffect, useRef, useState } from 'react';
import './index.scss';

export interface EcoNavPageItemProps {
    /**
     * 点击对应的ID
     */
    href: string;
    /**
     * 标题
     */
    title: string;
}
export interface EcoNavPageProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 样式名
     */
    className?: string;
    /***
     * 背景色
     */
    bgColor?: string;
    /***
     * 文案未被选中时的颜色
     */
    textColor?: string;
    /***
     * 文案被选中时的颜色
     */
    textActiveColor?: string;
    /**
     * 文案被选中时的背景颜色
     */
    textActiveBgColor?: string;
    /**
     * 列表
     */
    items: EcoNavPageItemProps[];
    /**
     * 默认选中第几个
     */
    initIndex?: number;
    /**
     * 是否处在编辑页面中
     */
    isEditStatus?: boolean;

    openGTM?: boolean;

    onClick?: any;
}
const defaultItem: EcoNavPageItemProps = {
    href: '',
    title: '',
};

/**
 * 维护:谢保林
 *
 * 锚点导航
 */
const EcoNavPage: React.FC<EcoNavPageProps> = ({
    theme = 'white',
    className,
    items = [],
    bgColor = '',
    textColor = '',
    textActiveColor = '',
    textActiveBgColor = '',
    initIndex = 0,
    isEditStatus = false,
    onClick,
    openGTM = true,
}) => {
    const prefixCls = `eco-nav-page`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
    });
    const tabsContainerRef: any = useRef<HTMLDivElement>();
    const activeItemRef = useRef<EcoNavPageItemProps>(items[initIndex] || defaultItem);

    const [activeItem, setActiveItem] = useState<EcoNavPageItemProps>(items[initIndex] || defaultItem);
    // 点击切换
    const toggleItemHandle = (item: EcoNavPageItemProps, index: number) => {
        setTimeout(() => {
            setActiveItem({
                href: item.href,
                title: '',
            });
        }, 100);
        setTimeout(() => {
            tabsContainerRef.current.scrollTo({
                left: 100 * index,
                behavior: 'smooth',
            });
        }, 150);
        openGTM &&
            gtm.push({
                event: 'uaEvent',
                event_name: 'tab_click',
                button_name: item.title,
                list_name: 'none',
                __btn_id1: `eco-nav-page .nav-tab-${index + 1}`,
                __btn_id2: `nav-tab-${index + 1}`,
                __btn_type: 'common',
            });

        onClick && onClick(item, index);
    };
    const compStyle = {
        '--nav-bgColor': bgColor,
        '--nav-textColor': textColor,
        '--nav-textActiveColor': textActiveColor,
        '--nav-textActiveBgColor': textActiveBgColor,
    } as React.CSSProperties;

    useEffect(() => {
        const offsetH = 200; //距离顶部200px时触发
        const bottomOffset = window.innerHeight - offsetH; //元素
        const observer = new IntersectionObserver(
            (elems: any) => {
                for (let i = 0; i < elems.length; i++) {
                    const elem = elems[i];
                    const id = `#${elem.target.id}`;
                    const topNum = elem.boundingClientRect.top;
                    //console.log('id', id, topNum, offsetH, elem.isIntersecting);
                    // console.log(elem.isIntersecting, elem);
                    if (elem.isIntersecting && topNum > 0 && topNum <= offsetH && activeItemRef.current.href !== id) {
                        setActiveItem({
                            href: id,
                            title: '',
                        });
                        activeItemRef.current = {
                            href: id,
                            title: '',
                        };
                    }
                }
            },
            {
                rootMargin: `0px 0px -${bottomOffset}px 0px`,
                threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1], //相对于元素自身(自身进入0%,自身进入100%)
            },
        );

        for (let i = 0; i < items.length; i++) {
            try {
                const item = items[i];
                const itemID = `${item.href}`.slice(1);
                const elem = document.querySelector(`.temp-${itemID}`);
                if (elem) {
                    observer.observe(elem);
                }
            } catch (error) {}
        }
    }, []);

    if (!items || !items.length) {
        return null;
    }

    return (
        <div className={classes} style={compStyle}>
            <div className={`${prefixCls}-shadow ${prefixCls}-shadow-l`}></div>
            <div className={`${prefixCls}-in`} ref={tabsContainerRef}>
                {items?.map((item: EcoNavPageItemProps, index: number) => {
                    const itemHref = item.href || '';
                    const hasID = itemHref.length > 1;
                    return (
                        <a
                            href={item.href}
                            key={`${index}${item.href}`}
                            className={`${prefixCls}-item${activeItem.href === item.href && hasID ? ` ${prefixCls}-item-active` : ''} item-${
                                index + 1
                            } GtmModule-btn-common`}
                            data-section-id={`nav-tab-${index + 1}`}
                            onClick={() => {
                                toggleItemHandle(item, index);
                            }}
                        >
                            <span className={`${prefixCls}-item-text`}>{item.title}</span>
                        </a>
                    );
                })}
            </div>
            <div className={`${prefixCls}-shadow ${prefixCls}-shadow-r`}></div>
        </div>
    );
};

export default EcoNavPage;
